import { useQuery } from '@tanstack/react-query'

import { UnitLeaseWithResidents } from '@/models/features'

import { authAPI } from '../new-api'

export interface GetUnitLeasesRequest {
  unitId: string
}

export type GetUnitLeasesResponse = UnitLeaseWithResidents[]

export const getUnitLeases = async ({ unitId }: GetUnitLeasesRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetUnitLeasesResponse>(`/units/${unitId}/leases`, { signal })
  return response.data
}

export const GET_UNIT_LEASES_BASE_QUERY_KEY = 'useGetUnitLeases'

export const getUnitLeasesQueryKey = (data: GetUnitLeasesRequest) =>
  [GET_UNIT_LEASES_BASE_QUERY_KEY, data] as const

export const useGetUnitLeases = (data: GetUnitLeasesRequest) => {
  return useQuery({
    enabled: !!data.unitId,
    queryFn: ({ signal }) => getUnitLeases(data, signal),
    queryKey: getUnitLeasesQueryKey(data),
  })
}
